module.exports = __webpack_public_path__ + "static/sprout-05881415fd05f7f2143af1a56e26786c.jpg";